export const ROLES_CONFIG = {
  ROUTES: {
    SignIn: [],
    ForgotPassword: [],
    NotFoundPage: [],
    ChangePassword: [],
    Employee: [
      // Level 1
      "MSH_HUMAN_RESOURCE_MANAGEMENT",
      // Level 2
      "MSH_EMPLOYEE_MANAGEMENT",
    ],
    TimeKeeping: [
      // Level 1
      "MSH_HUMAN_RESOURCE_MANAGEMENT",
      // Level 2
      "MSH_TIMEKEEPING_MANAGEMENT",
      // Level 3
      "MSH_LIST_TIMEKEEPING_MANAGEMENT",
      "MSH_PLACE_TIMEKEEPING_MANAGEMENT",
      "MSH_REPORT_TIMEKEEPING_MANAGEMENT",
    ],
    RegisterCheckIn: [
      // Level 1
      "MSH_HUMAN_RESOURCE_MANAGEMENT",
      // Level 2
      "MSH_REGISTER_CHECKIN",
    ],
    OnLeave: [
      // Level 1
      "MSH_HUMAN_RESOURCE_MANAGEMENT",
      // Level 2
      "MSH_LEAVE_MANAGEMENT",
    ],
    MakeupWorkRequest: [
      // Level 1
      "MSH_HUMAN_RESOURCE_MANAGEMENT",
      // Level 2
      "MSH_MAKE_UP_WORK_REQUEST_MANAGEMENT",
    ],
    attendanceSummary: [
      // Level 1
      "MSH_HUMAN_RESOURCE_MANAGEMENT",
      // Level 2
      "MSH_TIMEKEEPING_MANAGEMENT",
    ],
    DeviceActivityLog: [
      // Level 1
      "MSH_HUMAN_RESOURCE_MANAGEMENT",
      // Level 2
      "MSH_DEVICE_ACTIVITY_LOG",
    ],
    DeviceManager: [
      // Level 1
      "MSH_HUMAN_RESOURCE_MANAGEMENT",
      // Level 2
      "MSH_DEVICE_MANAGEMENT",
    ],
    FuelAllowance: [
      // Level 1
      "MSH_HUMAN_RESOURCE_MANAGEMENT",
      // Level 2
      "MSH_FUEL_ALLOWANCE_MANAGEMENT",
    ],
    JobTitle: [
      // Level 1
      "MSH_HUMAN_RESOURCE_MANAGEMENT",
      // Level 2
      "MSH_MONTHLY_CONFIRMATION_OF_WORK_AND_TITLE",
    ],
    ReceiveSalary: [
      // Level 1
      "MSH_HUMAN_RESOURCE_MANAGEMENT",
      // Level 2
      "MSH_MONTHLY_SALARY_REQUEST",
    ],
    relativeFormRequest: [
      // Level 1
      "MSH_HUMAN_RESOURCE_MANAGEMENT",
      // Level 2
      "RELATIVE_REGISTER_FORM_MANAGEMENT",
    ],
    ProjectManagement: [
      // Level 1
      "MSH_SALES_MANAGEMENT",
      // Level 2
      "MSH_PROJECT_MANAGEMENT",
    ],
    RateProjectAndApartment: [
      // Level 1
      "MSH_SALES_MANAGEMENT",
      // Level 2
      "MSH_RATE_PRODUCT_AND_APARTMENT_MANAGEMENT",
    ],
    Apartments: [
      // Level 1
      "MSH_SALES_MANAGEMENT",
      // Level 2
      "MSH_PRODUCT_AND_APARTMENT_MANAGEMENT",
    ],
    Booking: [
      // Level 1
      "MSH_SALES_MANAGEMENT",
      // Level 2
      "MSH_BOOKING_BATCH_MANAGEMENT",
    ],
    Banner: [
      // Level 1
      "MSH_SALES_MANAGEMENT",
      // Level 2
      "MSH_BANNER_MANAGEMENT",
    ],
    Contract: [
      // Level 1
      "MSH_SALES_MANAGEMENT",
      // Level 2
      "MSH_CONFIRMATION_SALES_CONTRACT",
    ],
    Ttkq: [
      // Level 1
      "MSH_SALES_MANAGEMENT",
      // Level 2
      "MSH_TTKQ_MANAGEMENT",
    ],
    BookingManagement: [
      // Level 1
      "MSH_SALES_MANAGEMENT",
      // Level 2
      "MSH_BOOKING_MANAGEMENT",
    ],
    Locking: [
      // Level 1
      "MSH_SALES_MANAGEMENT",
      // Level 2
      "MSH_LOOKING_MANAGEMENT",
    ],
    BrokerDebtCertificate: [
      // Level 1
      "MSH_SALES_MANAGEMENT",
      // Level 2
      "MSH_BROKER_DEBT_CERTIFICATE_MANAGEMENT",
    ],
    OpenForSale: [
      // Level 1
      "MSH_INVENTORY_MANAGEMENT",
      // Level 2
      "MSH_OPENING_SALE_MANAGEMENT",
    ],
    Customers: [
      // Level 1
      "MSH_INVENTORY_MANAGEMENT",
      // Level 2
      "MSH_CUSTOMER_MANAGEMENT",
    ],
    CustomerUpdateRequest: [
      // Level 1
      "MSH_INVENTORY_MANAGEMENT",
      // Level 2
      "MSH_CUSTOMER_EDIT_REQUEST_MANAGEMENT",
    ],
    PersonnelCategories: [
      // Level 1
      "MSH_CATEGORIES_MANAGEMENT",
      // Level 2
      "MSH_CATEGORIES_EMPLOYEE_MANAGEMENT",
      // Level 3
      "MSH_CATEGORIES_JOBTITLE_MANAGEMENT",
      "MSH_CATEGORIES_SUPPORT_DEPARTMENT_MANAGEMENT",
      "MSH_CATEGORIES_BRANCH_MANAGEMENT",
      "MSH_CATEGORIES_DEPARTMENT_MANAGEMENT",
      "MSH_CATEGORIES_SALE_AREA_MANAGEMENT",
      "MSH_CATEGORIES_SALE_BLOCK_MANAGEMENT",
      "MSH_CATEGORIES_BUSINESS_MANAGEMENT",
    ],
    OnLeaveCategories: [
      // Level 1
      "MSH_CATEGORIES_MANAGEMENT",
      // Level 2
      "MSH_CATEGORIES_WORK_AND_LEAVE_MANAGEMENT",
      // Level 3
      "MSH_CATEGORIES_HOLIDAY_MANAGEMENT",
      "MSH_CATEGORIES_BUSINESS_CATEGORY_MANAGEMENT",
      "MSH_CATEGORIES_BUSINESS_GUARANTEETYPE_MANAGEMENT",
    ],
    ProjectCategories: [
      // Level 1
      "MSH_CATEGORIES_MANAGEMENT",
      // Level 2
      "MSH_CATEGORIES_PROJECT_MANAGEMENT",
      // Level 3
      "MSH_CATEGORIES_PROJECT_DIVISION_MANAGEMENT",
      "MSH_CATEGORIES_PROJECT_PROJECTTYPE_MANAGEMENT",
      "MSH_CATEGORIES_TYPE_PROJECT_MANAGEMENT",
      "MSH_CATEGORIES_PROJECT_INVESTOR_MANAGEMENT",
      "MSH_CATEGORIES_PROJECT_CUSTOMER_TYPE_MANAGEMENT",
      "MSH_CATEGORIES_PROJECT_CITY_MANAGEMENT",
      "MSH_CATEGORIES_PROJECT_DIRECTION_MANAGEMENT",
      "MSH_CATEGORIES_PROJECT_PROPERTY_MANAGEMENT",
      "MSH_CATEGORIES_PROJECT_JOB_MANAGEMENT",
      "MSH_CATEGORIES_PROJECT_PDV_MANAGEMENT",
      "MSH_CATEGORY_PROVINCE_MANAGEMENT",
      "MSH_CATEGORY_PAYMENT_METHOD_MANAGEMENT",
    ],
    CommissionConfirmation: [
      // Level 1
      "MSH_INCOME_MANAGEMENT",
      // Level 2
      "MSH_COMMISSION_CONFIRMATION",
      // Level 3
    ],
    Statement: [
      // Level 1
      "MSH_INCOME_MANAGEMENT",
      // Level 2
      "MSH_REPORT_MANAGEMENT",
    ],
    Report: [
      // Level 1
      "MSH_INCOME_MANAGEMENT",
      // Level 2
      "MSH_REPORT_MANAGEMENT",
    ],
    ServiceFee: [
      // Level 1
      "MSH_INCOME_MANAGEMENT",
      // Level 2
      "MSH_SERVICE_FEE_MANAGEMENT",
    ],
    SalesManagement: [
      // Level 1
      "MSH_INCOME_MANAGEMENT",
      // Level 2
      "MSH_CATEGORIES_COMMISSION_SALES_MANAGEMENT",
    ],
    AdminManagement: [
      // level 1
      "MSH_ADMIN_MANAGEMENT",
      // level 2
      "MSH_ROLE_PERMISSION_MANAGEMENT",
    ],
    SettingManagement: [
      // level 1
      "MSH_ADMIN_MANAGEMENT",
      // level 2
      "MSH_SETTINGS",
    ],
    Logs: [
      // Level 1
      "MSH_LOGS",
    ],
    TransferRequests: [
      // Level 1
      "MSH_SALES_MANAGEMENT",
      // Level 2
      "MSH_TRANSFER_REQUESTS",
    ],
  },
  MENU: {
    MENU_QLNS: {
      role: [
        // Level 1
        "MSH_HUMAN_RESOURCE_MANAGEMENT",
        // Level 2
        "MSH_EMPLOYEE_MANAGEMENT",
        "MSH_TIMEKEEPING_MANAGEMENT",
        "MSH_LEAVE_MANAGEMENT",
        "MSH_MONTHLY_CONFIRMATION_OF_WORK_AND_TITLE",
        "MSH_MONTHLY_SALARY_REQUEST",
        "RELATIVE_REGISTER_FORM_MANAGEMENT",
        "MSH_FUEL_ALLOWANCE_MANAGEMENT",
        // Level 3
        "MSH_LIST_TIMEKEEPING_MANAGEMENT",
        "MSH_PLACE_TIMEKEEPING_MANAGEMENT",
        "MSH_REPORT_TIMEKEEPING_MANAGEMENT",
      ],
      CHILDREN: {
        CHILDREN_QLNV: {
          role: [
            // Level 1
            "MSH_HUMAN_RESOURCE_MANAGEMENT",
            // Level 2
            "MSH_EMPLOYEE_MANAGEMENT",
          ],
        },
        CHILDREN_QLCC: {
          role: [
            // Level 1
            "MSH_HUMAN_RESOURCE_MANAGEMENT",
            // Level 2
            "MSH_TIMEKEEPING_MANAGEMENT",
            // Level 3
            "MSH_LIST_TIMEKEEPING_MANAGEMENT",
            "MSH_PLACE_TIMEKEEPING_MANAGEMENT",
            "MSH_REPORT_TIMEKEEPING_MANAGEMENT",
          ],
          TAB: {
            TAB_DSCC: {
              role: [
                // Level 1
                "MSH_HUMAN_RESOURCE_MANAGEMENT",
                // Level 2
                "MSH_TIMEKEEPING_MANAGEMENT",
                // Level 3
                // "MSH_LIST_TIMEKEEPING_MANAGEMENT",
                "MSH_REPORT_TIMEKEEPING_MANAGEMENT",
              ],
            },
            TAB_DSDDCC: {
              role: [
                // Level 1
                "MSH_HUMAN_RESOURCE_MANAGEMENT",
                // Level 2
                "MSH_TIMEKEEPING_MANAGEMENT",
                // Level 3
                // "MSH_LIST_TIMEKEEPING_MANAGEMENT",
                "MSH_PLACE_TIMEKEEPING_MANAGEMENT",
              ],
            },
          },
        },
        CHILDREN_RCI: {
          role: [
            // Level 1
            "MSH_HUMAN_RESOURCE_MANAGEMENT",
            // Level 2
            "MSH_REGISTER_CHECKIN",
          ],
        },
        CHILDREN_XNP: {
          role: [
            // Level 1
            "MSH_HUMAN_RESOURCE_MANAGEMENT",
            // Level 2
            "MSH_LEAVE_MANAGEMENT",
          ],
        },
        CHILDREN_XNC_AND_CDHT: {
          role: [
            // Level 1
            "MSH_HUMAN_RESOURCE_MANAGEMENT",
            // Level 2
            "MSH_MONTHLY_CONFIRMATION_OF_WORK_AND_TITLE",
          ],
        },
        CHILDREN_XNL: {
          role: [
            // Level 1
            "MSH_HUMAN_RESOURCE_MANAGEMENT",
            // Level 2
            "MSH_MONTHLY_SALARY_REQUEST",
          ],
        },
        CHILDREN_PDKNT: {
          role: [
            // Level 1
            "MSH_HUMAN_RESOURCE_MANAGEMENT",
            // Level 2
            "RELATIVE_REGISTER_FORM_MANAGEMENT",
          ],
        },
        MSH_MAKE_UP_WORK_REQUEST_MANAGEMENT: {
          role: [
            // Level 1
            "MSH_HUMAN_RESOURCE_MANAGEMENT",
            // Level 2
            "MSH_MAKE_UP_WORK_REQUEST_MANAGEMENT",
          ],
        },
        MSH_DEVICE_ACTIVITY_LOG: {
          role: [
            // Level 1
            "MSH_HUMAN_RESOURCE_MANAGEMENT",
            // Level 2
            "MSH_DEVICE_ACTIVITY_LOG",
          ],
        },
        CHILDREN_CC: {
          role: [
            // Level 1
            "MSH_HUMAN_RESOURCE_MANAGEMENT",
            // Level 2
            "MSH_TIMEKEEPING_MANAGEMENT",
          ],
        },
        CHILDREN_DEVICE_MANAGER: {
          role: [
            // Level 1
            "MSH_HUMAN_RESOURCE_MANAGEMENT",
            // Level 2
            "MSH_DEVICE_MANAGEMENT",
          ],
        },
        CHILDREN_FUEL_ALLOWANCE: {
          role: [
            // Level 1
            "MSH_HUMAN_RESOURCE_MANAGEMENT",
            // Level 2
            "MSH_FUEL_ALLOWANCE_MANAGEMENT",
          ],
        },
      },
    },
    MENU_QLNH: {
      role: [
        // Level 1
        "MSH_INVENTORY_MANAGEMENT",
        // Level 2
        "MSH_PROJECT_MANAGEMENT",
        "MSH_PRODUCT_AND_APARTMENT_MANAGEMENT",
        "MSH_BOOKING_BATCH_MANAGEMENT",
        "MSH_BANNER_MANAGEMENT",
      ],
      CHILDREN: {
        CHILDREN_QLDA: {
          role: [
            // Level 1
            "MSH_INVENTORY_MANAGEMENT",
            // Level 2
            "MSH_PROJECT_MANAGEMENT",
          ],
        },
        CHILDREN_QLSP_AND_CH: {
          role: [
            // Level 1
            "MSH_INVENTORY_MANAGEMENT",
            // Level 2
            "MSH_PRODUCT_AND_APARTMENT_MANAGEMENT",
          ],
        },
        CHILDREN_DN_BOOKING: {
          role: [
            // Level 1
            "MSH_INVENTORY_MANAGEMENT",
            // Level 2
            "MSH_BOOKING_BATCH_MANAGEMENT",
          ],
        },
        CHILDREN_QL_BANNER: {
          role: [
            // Level 1
            "MSH_INVENTORY_MANAGEMENT",
            // Level 2
            "MSH_BANNER_MANAGEMENT",
          ],
        },
      },
    },
    MENU_QLBH: {
      role: [
        // Level 1
        "MSH_SALES_MANAGEMENT",
        // Level 2
        "MSH_OPENING_SALE_MANAGEMENT",
        "MSH_CUSTOMER_MANAGEMENT",
        "MSH_CUSTOMER_EDIT_REQUEST_MANAGEMENT",
        "MSH_BOOKING_MANAGEMENT",
        "MSH_LOOKING_MANAGEMENT",
        "MSH_BROKER_DEBT_CERTIFICATE_MANAGEMENT",
        "MSH_TTKQ_MANAGEMENT",
        "MSH_CONFIRMATION_SALES_CONTRACT",
      ],
      CHILDREN: {
        CHILDREN_QLDMB: {
          role: [
            // Level 1
            "MSH_SALES_MANAGEMENT",
            // Level 2
            "MSH_OPENING_SALE_MANAGEMENT",
          ],
        },
        CHILDREN_QLKH: {
          role: [
            // Level 1
            "MSH_SALES_MANAGEMENT",
            // Level 2
            "MSH_CUSTOMER_MANAGEMENT",
          ],
        },
        CHILDREN_QL_BOOKING: {
          role: [
            // Level 1
            "MSH_SALES_MANAGEMENT",
            // Level 2
            "MSH_BOOKING_MANAGEMENT",
          ],
        },
        CHILDREN_QL_LOCKING: {
          role: [
            // Level 1
            "MSH_SALES_MANAGEMENT",
            // Level 2
            "MSH_LOOKING_MANAGEMENT",
          ],
        },
        CHILDREN_QL_MSH_BROKER_DEBT_CERTIFICATE_MANAGEMENT: {
          role: [
            // Level 1
            "MSH_SALES_MANAGEMENT",
            // Level 2
            "MSH_BROKER_DEBT_CERTIFICATE_MANAGEMENT",
          ],
        },
        CHILDREN_PCSKH: {
          role: [
            // Level 1
            "MSH_SALES_MANAGEMENT",
            // Level 2
            "MSH_CUSTOMER_EDIT_REQUEST_MANAGEMENT",
          ],
        },
        CHILDREN_XNTTKQ: {
          role: [
            // Level 1
            "MSH_SALES_MANAGEMENT",
            // Level 2
            "MSH_TTKQ_MANAGEMENT",
          ],
        },
        CHILDREN_XNHDMB: {
          role: [
            // Level 1
            "MSH_SALES_MANAGEMENT",
            // Level 2
            "MSH_CONFIRMATION_SALES_CONTRACT",
          ],
        },
        CHILDREN_TRANSFER_REQUESTS: {
          role: [
            // Level 1
            "MSH_SALES_MANAGEMENT",
            // Level 2
            "MSH_TRANSFER_REQUESTS",
          ],
        },
      },
    },
    MENU_QLDM: {
      role: [
        // Level 1
        "MSH_CATEGORIES_MANAGEMENT",
        // Level 2
        "MSH_CATEGORIES_EMPLOYEE_MANAGEMENT",
        "MSH_CATEGORIES_WORK_AND_LEAVE_MANAGEMENT",
        "MSH_CATEGORIES_PROJECT_MANAGEMENT",
        // Level 3
        "MSH_CATEGORIES_JOBTITLE_MANAGEMENT",
        "MSH_CATEGORIES_SUPPORT_DEPARTMENT_MANAGEMENT",
        "MSH_CATEGORIES_BRANCH_MANAGEMENT",
        "MSH_CATEGORIES_DEPARTMENT_MANAGEMENT",
        "MSH_CATEGORIES_SALE_AREA_MANAGEMENT",
        "MSH_CATEGORIES_SALE_BLOCK_MANAGEMENT",
        "MSH_CATEGORIES_BUSINESS_MANAGEMENT",

        "MSH_CATEGORIES_HOLIDAY_MANAGEMENT",
        "MSH_CATEGORIES_BUSINESS_CATEGORY_MANAGEMENT",
        "MSH_CATEGORIES_BUSINESS_GUARANTEETYPE_MANAGEMENT",

        "MSH_CATEGORIES_PROJECT_DIVISION_MANAGEMENT",
        "MSH_CATEGORIES_PROJECT_PROJECTTYPE_MANAGEMENT",
        "MSH_CATEGORIES_TYPE_PROJECT_MANAGEMENT",
        "MSH_CATEGORIES_PROJECT_INVESTOR_MANAGEMENT",
        "MSH_CATEGORIES_PROJECT_CUSTOMER_TYPE_MANAGEMENT",
        "MSH_CATEGORIES_PROJECT_CITY_MANAGEMENT",
        "MSH_CATEGORIES_PROJECT_DIRECTION_MANAGEMENT",
        "MSH_CATEGORIES_PROJECT_PROPERTY_MANAGEMENT",
        "MSH_CATEGORIES_PROJECT_JOB_MANAGEMENT",
        "MSH_CATEGORIES_PROJECT_PDV_MANAGEMENT",
        "MSH_CATEGORY_PROVINCE_MANAGEMENT",
        "MSH_CATEGORY_PAYMENT_METHOD_MANAGEMENT",
        "MSH_CATEGORY_AGENT_MANAGEMENT",
      ],
      CHILDREN: {
        CHILDREN_NS: {
          role: [
            // Level 1
            "MSH_CATEGORIES_MANAGEMENT",
            // Level 2
            "MSH_CATEGORIES_EMPLOYEE_MANAGEMENT",
            // Level 3
            "MSH_CATEGORIES_JOBTITLE_MANAGEMENT",
            "MSH_CATEGORIES_SUPPORT_DEPARTMENT_MANAGEMENT",
            "MSH_CATEGORIES_BRANCH_MANAGEMENT",
            "MSH_CATEGORIES_DEPARTMENT_MANAGEMENT",
            "MSH_CATEGORIES_SALE_AREA_MANAGEMENT",
            "MSH_CATEGORIES_SALE_BLOCK_MANAGEMENT",
            "MSH_CATEGORIES_BUSINESS_MANAGEMENT",
          ],
          TAB: {
            TAB_CD_AND_PB_AND_CN: {
              role: [
                // Level 1
                "MSH_CATEGORIES_MANAGEMENT",
                // Level 2
                "MSH_CATEGORIES_EMPLOYEE_MANAGEMENT",
                // Level 3
                "MSH_CATEGORIES_JOBTITLE_MANAGEMENT",
                "MSH_CATEGORIES_SUPPORT_DEPARTMENT_MANAGEMENT",
                "MSH_CATEGORIES_BRANCH_MANAGEMENT",
              ],
              CHILDREN_TAB: {
                CHILDREN_TAB_DSCD: {
                  role: [
                    "MSH_CATEGORIES_MANAGEMENT",
                    "MSH_CATEGORIES_EMPLOYEE_MANAGEMENT",
                    "MSH_CATEGORIES_JOBTITLE_MANAGEMENT",
                  ],
                },
                CHILDREN_TAB_DSPB: {
                  role: [
                    "MSH_CATEGORIES_MANAGEMENT",
                    "MSH_CATEGORIES_EMPLOYEE_MANAGEMENT",
                    "MSH_CATEGORIES_SUPPORT_DEPARTMENT_MANAGEMENT",
                  ],
                },
                CHILDREN_TAB_DSCN: {
                  role: [
                    "MSH_CATEGORIES_MANAGEMENT",
                    "MSH_CATEGORIES_EMPLOYEE_MANAGEMENT",
                    "MSH_CATEGORIES_BRANCH_MANAGEMENT",
                  ],
                },
              },
            },
            TAB_KBP_AND_V_AND_K: {
              role: [
                // Level 1
                "MSH_CATEGORIES_MANAGEMENT",
                // Level 2
                "MSH_CATEGORIES_EMPLOYEE_MANAGEMENT",
                // Level 3
                "MSH_CATEGORIES_DEPARTMENT_MANAGEMENT",
                "MSH_CATEGORIES_SALE_AREA_MANAGEMENT",
                "MSH_CATEGORIES_SALE_BLOCK_MANAGEMENT",
                "MSH_CATEGORIES_BUSINESS_MANAGEMENT",
              ],
              CHILDREN_TAB: {
                CHILDREN_TAB_KBP: {
                  role: [
                    "MSH_CATEGORIES_MANAGEMENT",
                    "MSH_CATEGORIES_EMPLOYEE_MANAGEMENT",
                    "MSH_CATEGORIES_DEPARTMENT_MANAGEMENT",
                  ],
                },
                CHILDREN_TAB_V: {
                  role: [
                    "MSH_CATEGORIES_MANAGEMENT",
                    "MSH_CATEGORIES_EMPLOYEE_MANAGEMENT",
                    "MSH_CATEGORIES_SALE_AREA_MANAGEMENT",
                  ],
                },
                CHILDREN_TAB_K: {
                  role: [
                    "MSH_CATEGORIES_MANAGEMENT",
                    "MSH_CATEGORIES_EMPLOYEE_MANAGEMENT",
                    "MSH_CATEGORIES_SALE_BLOCK_MANAGEMENT",
                  ],
                },
                CHILDREN_TAB_PLNVKD: {
                  role: [
                    "MSH_CATEGORIES_MANAGEMENT",
                    "MSH_CATEGORIES_EMPLOYEE_MANAGEMENT",
                    "MSH_CATEGORIES_BUSINESS_MANAGEMENT",
                  ],
                },
              },
            },
            TAB_PJ: {
              role: [
                // Level 1
                "MSH_CATEGORIES_MANAGEMENT",
                // Level 2
                "MSH_CATEGORIES_EMPLOYEE_MANAGEMENT",
                // Level 3
              ],
              // CHILDREN_TAB: {
              //   CHILDREN_TAB_KBP: {
              //     role: [
              //       "MSH_CATEGORIES_MANAGEMENT",
              //       "MSH_CATEGORIES_EMPLOYEE_MANAGEMENT",
              //       "MSH_CATEGORIES_DEPARTMENT_MANAGEMENT",
              //     ],
              //   },
              //   CHILDREN_TAB_V: {
              //     role: [
              //       "MSH_CATEGORIES_MANAGEMENT",
              //       "MSH_CATEGORIES_EMPLOYEE_MANAGEMENT",
              //       "MSH_CATEGORIES_SALE_AREA_MANAGEMENT",
              //     ],
              //   },
              //   CHILDREN_TAB_K: {
              //     role: [
              //       "MSH_CATEGORIES_MANAGEMENT",
              //       "MSH_CATEGORIES_EMPLOYEE_MANAGEMENT",
              //       "MSH_CATEGORIES_SALE_BLOCK_MANAGEMENT",
              //     ],
              //   },
              //   CHILDREN_TAB_PLNVKD: {
              //     role: [
              //       "MSH_CATEGORIES_MANAGEMENT",
              //       "MSH_CATEGORIES_EMPLOYEE_MANAGEMENT",
              //       "MSH_CATEGORIES_BUSINESS_MANAGEMENT",
              //     ],
              //   },
              // },
            },
          },
        },
        CHILDREN_C_AND_NP: {
          role: [
            // Level 1
            "MSH_CATEGORIES_MANAGEMENT",
            // Level 2
            "MSH_CATEGORIES_WORK_AND_LEAVE_MANAGEMENT",
            // Level 3
            "MSH_CATEGORIES_HOLIDAY_MANAGEMENT",
            "MSH_CATEGORIES_BUSINESS_CATEGORY_MANAGEMENT",
            "MSH_CATEGORIES_BUSINESS_GUARANTEETYPE_MANAGEMENT",
          ],
          CHILDREN_TAB_HOLIDAY: {
            role: [
              "MSH_CATEGORIES_MANAGEMENT",
              "MSH_CATEGORIES_WORK_AND_LEAVE_MANAGEMENT",
              "MSH_CATEGORIES_HOLIDAY_MANAGEMENT",
            ],
          },
          CHILDREN_TAB_BUSINESS_CATEGORY: {
            role: [
              "MSH_CATEGORIES_MANAGEMENT",
              "MSH_CATEGORIES_WORK_AND_LEAVE_MANAGEMENT",
              "MSH_CATEGORIES_BUSINESS_CATEGORY_MANAGEMENT",
            ],
          },
          CHILDREN_TAB_BUSINESS_GUARANTEETYPE: {
            role: [
              "MSH_CATEGORIES_MANAGEMENT",
              "MSH_CATEGORIES_WORK_AND_LEAVE_MANAGEMENT",
              "MSH_CATEGORIES_BUSINESS_GUARANTEETYPE_MANAGEMENT",
            ],
          },
        },
        CHILDREN_DA: {
          role: [
            // Level 1
            "MSH_CATEGORIES_MANAGEMENT",
            // Level 2
            "MSH_CATEGORIES_PROJECT_MANAGEMENT",
            // Level 3
            "MSH_CATEGORIES_PROJECT_DIVISION_MANAGEMENT",
            "MSH_CATEGORIES_PROJECT_PROJECTTYPE_MANAGEMENT",
            "MSH_CATEGORIES_TYPE_PROJECT_MANAGEMENT",
            "MSH_CATEGORIES_PROJECT_INVESTOR_MANAGEMENT",
            "MSH_CATEGORIES_PROJECT_CUSTOMER_TYPE_MANAGEMENT",
            "MSH_CATEGORIES_PROJECT_CITY_MANAGEMENT",
            "MSH_CATEGORIES_PROJECT_DIRECTION_MANAGEMENT",
            "MSH_CATEGORIES_PROJECT_PROPERTY_MANAGEMENT",
            "MSH_CATEGORIES_PROJECT_JOB_MANAGEMENT",
            "MSH_CATEGORIES_PROJECT_PDV_MANAGEMENT",
            "MSH_CATEGORY_PROVINCE_MANAGEMENT",
            "MSH_CATEGORY_PAYMENT_METHOD_MANAGEMENT",
            "MSH_CATEGORY_AGENT_MANAGEMENT",
          ],
          TAB: {
            TAB_DA: {
              role: [
                // Level 1
                "MSH_CATEGORIES_MANAGEMENT",
                // Level 2
                "MSH_CATEGORIES_PROJECT_MANAGEMENT",
                // Level 3
                "MSH_CATEGORIES_PROJECT_DIVISION_MANAGEMENT",
                "MSH_CATEGORIES_PROJECT_PROJECTTYPE_MANAGEMENT",
                "MSH_CATEGORIES_TYPE_PROJECT_MANAGEMENT",
              ],
              CHILDREN_TAB: {
                CHILDREN_TAB_DSPK: {
                  role: [
                    "MSH_CATEGORIES_MANAGEMENT",
                    "MSH_CATEGORIES_PROJECT_MANAGEMENT",
                    "MSH_CATEGORIES_PROJECT_DIVISION_MANAGEMENT",
                  ],
                },
                CHILDREN_TAB_LHDA: {
                  role: [
                    "MSH_CATEGORIES_MANAGEMENT",
                    "MSH_CATEGORIES_PROJECT_MANAGEMENT",
                    "MSH_CATEGORIES_PROJECT_PROJECTTYPE_MANAGEMENT",
                  ],
                },
                CHILDREN_TAB_DSLHSP: {
                  role: [
                    "MSH_CATEGORIES_MANAGEMENT",
                    "MSH_CATEGORIES_PROJECT_MANAGEMENT",
                    "MSH_CATEGORIES_TYPE_PROJECT_MANAGEMENT",
                  ],
                },
              },
            },
            TAB_CDT: {
              role: [
                // Level 1
                "MSH_CATEGORIES_MANAGEMENT",
                // Level 2
                "MSH_CATEGORIES_PROJECT_MANAGEMENT",
                // Level 3
                "MSH_CATEGORIES_INVESTOR_MANAGEMENT",
              ],
              CHILDREN_TAB: {
                CHILDREN_TAB_KBP: {
                  role: [
                    "MSH_CATEGORIES_MANAGEMENT",
                    "MSH_CATEGORIES_PROJECT_MANAGEMENT",
                    "MSH_CATEGORIES_INVESTOR_MANAGEMENT",
                  ],
                },
              },
            },
            TAB_KH: {
              role: [
                // Level 1
                "MSH_CATEGORIES_MANAGEMENT",
                // Level 2
                "MSH_CATEGORIES_PROJECT_MANAGEMENT",
                // Level 3
                "MSH_CATEGORIES_PROJECT_CUSTOMER_TYPE_MANAGEMENT",
              ],
              CHILDREN_TAB: {
                CHILDREN_CUSTOMER_TYPE: {
                  role: [
                    "MSH_CATEGORIES_MANAGEMENT",
                    "MSH_CATEGORIES_PROJECT_MANAGEMENT",
                    "MSH_CATEGORIES_PROJECT_CUSTOMER_TYPE_MANAGEMENT",
                  ],
                },
              },
            },
            TAB_K: {
              role: [
                // Level 1
                "MSH_CATEGORIES_MANAGEMENT",
                // Level 2
                "MSH_CATEGORIES_PROJECT_MANAGEMENT",
                // Level 3
                "MSH_CATEGORIES_PROJECT_CITY_MANAGEMENT",
                "MSH_CATEGORIES_PROJECT_DIRECTION_MANAGEMENT",
                "MSH_CATEGORIES_PROJECT_PROPERTY_MANAGEMENT",
                "MSH_CATEGORIES_PROJECT_JOB_MANAGEMENT",
                "MSH_CATEGORIES_PROJECT_PDV_MANAGEMENT",
                "MSH_CATEGORY_PROVINCE_MANAGEMENT",
                "MSH_CATEGORY_PAYMENT_METHOD_MANAGEMENT",
                "MSH_CATEGORY_AGENT_MANAGEMENT",
              ],
              CHILDREN_TAB: {
                CHILDREN_TAB_CITY: {
                  role: [
                    "MSH_CATEGORIES_MANAGEMENT",
                    "MSH_CATEGORIES_PROJECT_MANAGEMENT",
                    "MSH_CATEGORIES_PROJECT_CITY_MANAGEMENT",
                  ],
                },
                CHILDREN_TAB_DIRECTION: {
                  role: [
                    "MSH_CATEGORIES_MANAGEMENT",
                    "MSH_CATEGORIES_PROJECT_MANAGEMENT",
                    "MSH_CATEGORIES_PROJECT_DIRECTION_MANAGEMENT",
                  ],
                },
                CHILDREN_TAB_PROPERTY: {
                  role: [
                    "MSH_CATEGORIES_MANAGEMENT",
                    "MSH_CATEGORIES_PROJECT_MANAGEMENT",
                    "MSH_CATEGORIES_PROJECT_PROPERTY_MANAGEMENT",
                  ],
                },
                CHILDREN_TAB_JOB: {
                  role: [
                    "MSH_CATEGORIES_MANAGEMENT",
                    "MSH_CATEGORIES_PROJECT_MANAGEMENT",
                    "MSH_CATEGORIES_PROJECT_JOB_MANAGEMENT",
                  ],
                },
                CHILDREN_TAB_PDV: {
                  role: [
                    "MSH_CATEGORIES_MANAGEMENT",
                    "MSH_CATEGORIES_PROJECT_MANAGEMENT",
                    "MSH_CATEGORIES_PROJECT_PDV_MANAGEMENT",
                  ],
                },
                CHILDREN_TAB_PROVINCE: {
                  role: [
                    "MSH_CATEGORIES_MANAGEMENT",
                    "MSH_CATEGORIES_PROJECT_MANAGEMENT",
                    "MSH_CATEGORY_PROVINCE_MANAGEMENT",
                  ],
                },
                CHILDREN_TAB_PAY: {
                  role: [
                    "MSH_CATEGORIES_MANAGEMENT",
                    "MSH_CATEGORIES_PROJECT_MANAGEMENT",
                    "MSH_CATEGORY_PAYMENT_METHOD_MANAGEMENT",
                  ],
                },
                CHILDREN_TAB_AGENT: {
                  role: [
                    "MSH_CATEGORIES_MANAGEMENT",
                    "MSH_CATEGORIES_PROJECT_MANAGEMENT",
                    "MSH_CATEGORY_AGENT_MANAGEMENT",
                  ],
                },
              },
            },
          },
        },
        // CHILDREN_SP: {
        //   role: [
        //     // Level 1
        //     "MSH_CATEGORIES_MANAGEMENT",
        //     // Level 2
        //     "MSH_CATEGORIES_PRODUCT_MANAGEMENT",
        //   ],
        // },
      },
    },
    MENU_QLDS: {
      role: [
        // Level 1
        "MSH_INCOME_MANAGEMENT",
        // Level 2
        "MSH_COMMISSION_CONFIRMATION",
        "MSH_CATEGORIES_COMMISSION_SALES_MANAGEMENT",
        "MSH_REPORT_MANAGEMENT",
        "MSH_SERVICE_FEE_MANAGEMENT",
      ],
      CHILDREN: {
        CHILDREN_XNPDV: {
          role: [
            // Level 1
            "MSH_INCOME_MANAGEMENT",
            // Level 2
            "MSH_COMMISSION_CONFIRMATION",
          ],
        },
        CHILDREN_QLDS: {
          role: [
            // Level 1
            "MSH_INCOME_MANAGEMENT",
            // Level 2
            "MSH_CATEGORIES_COMMISSION_SALES_MANAGEMENT",
          ],
        },
        CHILDREN_BC: {
          role: [
            // Level 1
            "MSH_INCOME_MANAGEMENT",
            // Level 2
            "MSH_REPORT_MANAGEMENT",
          ],
        },
        CHILDREN_DV: {
          role: [
            // Level 1
            "MSH_INCOME_MANAGEMENT",
            // Level 2
            "MSH_SERVICE_FEE_MANAGEMENT",
          ],
        },
      },
    },
    MENU_QL_SETTING: {
      role: [
        // Level 1
        "MSH_ADMIN_MANAGEMENT",
        // Level 2
        "MSH_ROLE_PERMISSION_MANAGEMENT",
        "MSH_SETTINGS",
      ],
      CHILDREN: {
        CHILDREN_ADMIN: {
          role: [
            // Level 1
            "MSH_ADMIN_MANAGEMENT",
            // Level 2
            "MSH_ROLE_PERMISSION_MANAGEMENT",
          ],
        },
        CHILDREN_SETTING: {
          role: [
            // Level 1
            "MSH_ADMIN_MANAGEMENT",
            // Level 2
            "MSH_SETTINGS",
          ],
        },
      },
    },
  },
};
